export default [
    {
        title: 'subscription.duration', price: `9.99`
    },
    {
        title: 'subscription.duration.year', price: `99.99`
    }
];